import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { HelperService } from '../../helper.service';
import { NavBarComponent } from '../../nav-bar/nav-bar.component';
import { BaseService } from '../../services/base.service';
import { Group } from 'src/app/models/group';
import { MatTableDataSource } from '@angular/material/table';
import { GroupService } from 'src/app/services/group.service';
import {catchError, Subscription, throwError} from 'rxjs';
import { PinType } from 'src/app/models/pinType';
import dayjs from "dayjs";
import { PinManagerService } from 'src/app/services/pin-manager.service';
import { MatDialog } from '@angular/material/dialog';
import { AddNewGroupComponent } from 'src/app/dialogs/add-new-group/add-new-group.component';
import { MergeGroupsComponent } from 'src/app/dialogs/merge-groups/merge-groups.component';
import { NewDeletePinComponent } from 'src/app/dialogs/pin-rework-dialogs/new-delete-pin/new-delete-pin.component';
import { TenantService } from 'src/app/services/tenant.service';
import {PIN_ICONS} from "../../dialogs/pin-rework-dialogs/new-save-pin/new-save-pin.component";

@Component({
    selector: 'app-sample-groups',
    templateUrl: './sample-groups.component.html',
    styleUrls: ['./sample-groups.component.css'],
    standalone: false
})
export class SampleGroupsComponent extends BaseService implements OnInit, OnDestroy {

  sampleGroupForm: FormGroup;

  @ViewChild(MatPaginator) paginatorAllPins: MatPaginator
  @ViewChild(MatSort) sort: MatSort;

  currentPage: number = 0;
  pageSize: number =  25;
  totalElements: number = 0;
  pinType: PinType;
  pintypeId: string = '0';
  mergeWithGroupId: number = 0;

  selectedPin: number = 0;

  protected readonly dayjs = dayjs;
 
  dateStringFormatting = 'YYYY-MM-DD';
  placeholder: string = "-";
  startDate: string;
  endDate: string;
  searchValue: string = null;

  displayedColumns: string[] = [
      'table-checkboxes',
      'table-groupName',
      'table-pinType',
      'table-sample-count',
      'table-dateCreated',
      'table-created-by',
      'table-actions'];
  dataSource = new MatTableDataSource<Group>([]);
  pinTypesList: PinType [] = [];
  selectedToMerge = [];

  subscriptions: Subscription[] = [];
  filterStartDate: string = '';
  filterEndDate  : string = '';
  tableHeight: string = '';
  showToolTip: boolean = false;
  isFilterBtnVisible: boolean = false;
  showPinTypeMenu: boolean = false;
  showPageSizeMenu: boolean = false;

  isGroupItemSelected: boolean = false;

  constructor(
      public helper: HelperService,
      private router: Router,
      public nav: NavBarComponent,
      private groupService: GroupService,
      private pinManagerService: PinManagerService,
      public mergeGroupDialog: MatDialog,
      private tenantService: TenantService
  ) {
    super();

    this.sampleGroupForm = new FormGroup({
      pinType: new FormControl(null)
  });
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.tableHeight = (window.innerHeight - 320) + 'px';
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.showPinTypeMenu = false;
    this.showPageSizeMenu = false;
  }


  isNoItemsFound: boolean = false;


  ngOnInit() {
    //REFRESH & POPULATE LIST ON TENANT CHANGE/UPDATE
    this.subscriptions.push(this.tenantService.currenttenantId.subscribe(tenantId => {
      if (tenantId) {
        this.populateGroupList();
      }
    }));


    this.populatePinTypesListDropDown();
        setTimeout(()=>{
      this.setSelectedPinType(this.pinType);
    }, 800);

    const defaultStartDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
    const defaultEndDate = dayjs().format('YYYY-MM-DD');

    this.filterStartDate = defaultStartDate;
    this.filterEndDate = defaultEndDate;

    this.startDate = dayjs(this.filterStartDate).format('YYYY-MM-DD');
    this.endDate = dayjs(this.filterEndDate).format('YYYY-MM-DD');

this.populateGroupList();
  }

  populateGroupList(){
    this.nav.toggleLoading(true);

    let tenantId = Number(sessionStorage.getItem("selectedTenant"));

    this.groupService.getPaginatedGroupListByTenantId(
      tenantId,
      this.currentPage,
      this.pageSize,
      this.searchValue,
      this.startDate,
      this.endDate,
      this.pinType?.id
    ).pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe((response) =>{
      this.dataSource.data = response.content;
      this.isNoItemsFound = response?.content.length <= 0;

      // this.dataSource = new MatTableDataSource<NewPin>(result.content);
    this.hideShowFilterReset();
  setTimeout(()=> {
      this.nav.toggleLoading(false);
  },1400)

      this.totalElements = response.totalElements;
    });

  }


  onPaginateChange(event: PageEvent) {
    this.clearSelectedPins();
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.totalElements = event.length;
    this.populateGroupList();
  }

  goToPage(page: number) {
    this.clearSelectedPins();
    this.currentPage = page;
    this.populateGroupList();
  }

  onPageSizeChange() {
    this.currentPage = 0;
    this.clearSelectedPins();
    this.populateGroupList();
  }

  get lastPage(): number {
    return Math.max(0, Math.ceil(this.totalElements / this.pageSize) - 1);
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }

  clearSelectedPins() {
    this.isGroupItemSelected = false;
    this.selectedToMerge = [];
  }


  toggleAllSelection(event: any): void {
    this.isGroupItemSelected = event.target.checked;
    this.dataSource.data.forEach(item => {
        this.onGroupSelectedChecked(event, item.id);
    });
  }


  onGroupSelectedChecked(event: any, id:number) {
    const checked = event?.target?.checked ?? event?.checked ?? false;
    if (checked) {
      if(!this.selectedToMerge.includes(id)) {
        this.selectedToMerge.push(id);
      }
    } else {
      const index = this.selectedToMerge.indexOf(id);
      if (index > -1) {
        this.selectedToMerge.splice(index, 1);
      }
    }
  }


    viewSampleGroup(id:number, name:string){
        if(id && name){
          sessionStorage.setItem('sampleGroupName', name);
          sessionStorage.setItem('sampleGroupId', String(id));
          this.router.navigate([`all-samples/${id}`]);
        }
  } 


  populatePinTypesListDropDown() {
    this.pinManagerService.getPinTypesList().pipe(
            catchError((error) => {
              console.error(error);
              return throwError(() => error);
            })
        )
        .subscribe((response) => {
          

          this.pinType = {
            id: 0,
            name: 'All',
            dateModified: ' '
          }

          this.pinTypesList.push(this.pinType);

          for(let pinType of response) {
            if(pinType?.name?.toLowerCase().includes('soil') || pinType?.name?.toLowerCase().includes('soft')) {
              this.pinTypesList.push(pinType)
            }
          }
          
          this.sampleGroupForm.controls.pinType.setValue(this.pinType);

          this.nav.toggleLoading(false);
        });
  }

  setSelectedPinType(pinType: PinType){
    this.clearSelectedGroups();
    this.pinType = this.sampleGroupForm.controls.pinType.value;
    this.sampleGroupForm.controls.pinType.setValue(pinType);
    this.populateGroupList();
  }

  selectPinType(pt: PinType) {
    this.showPinTypeMenu = false;
    this.pinType = pt;
    this.sampleGroupForm.controls.pinType.setValue(pt);
    this.clearSelectedGroups();
    this.populateGroupList();
  }


  addNewGroup(){
    const dialogRef = this.mergeGroupDialog.open(AddNewGroupComponent, {
      panelClass: ['compact-dialog', 'no-scroll-dialog'],
      data: {
        userId: this.helper.getUserId(),
        tenantId: sessionStorage.getItem('selectedTenant'),
      },
      width: '420px',
      height: 'auto',
      maxHeight: '90vh',
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.populateGroupList();
    });
  }

    hideShowFilterReset(){
      const defaultStartDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
      const defaultEndDate = dayjs().format('YYYY-MM-DD');
      if(this.startDate !== defaultStartDate || this.endDate !== defaultEndDate || this.searchValue || this.pinType.name !== 'All'){
        this.isFilterBtnVisible = true;
      }else{
        this.isFilterBtnVisible = false;
      }
    }

  clearSelectedGroups() {
    for(let id of this.selectedToMerge) {
      this.onGroupSelectedChecked(false, id);
    }
    this.selectedToMerge = [];
    this.isGroupItemSelected = false;
  }


  openMergeWithDialog(){
    
    const dialogRef = this.mergeGroupDialog.open(MergeGroupsComponent, {
      panelClass: 'compact-dialog',
      data: {
        userId: this.helper.getUserId(),
        tenantId: sessionStorage.getItem('selectedTenant'),
        selectedGroups: this.selectedToMerge
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.groupObj.option == 'merge'){
        this.mergeWithGroupId = result.groupObj.groupId
        this.mergeSelectedGroups();
        this.isGroupItemSelected = false;
        this.sampleGroupForm.controls.isGroupSelected.setValue(false);
      }
    });
  }

  mergeSelectedGroups(){
    this.selectedToMerge.forEach((groupId) =>{
      
    this.groupService.updateMergeSampleGroups(groupId, this.mergeWithGroupId).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
  )
  .subscribe((response) => {
    
    this.populateGroupList();
    this.selectedToMerge = [];
    this.nav.toggleLoading(false);
    });
  })
  }

  openDeleteGroupsDialog() {
    const count = this.selectedToMerge.length;
    const dialogRef = this.mergeGroupDialog.open(NewDeletePinComponent, {
      panelClass: 'compact-dialog',
      data: {
        isBulkDelete: true,
        description: count === 1 ? 'Sample Group' : count + ' Sample Group(s)',
        field: 'the selected group(s)'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.option === 'delete') {
        this.deleteSelectedGroups();
      }
    });
  }

  deleteSelectedGroups() {
    this.nav.toggleLoading(true);
    this.selectedToMerge.forEach(groupId => {
      this.groupService.deleteGroupById(groupId).pipe(
        catchError(error => { console.error(error); return throwError(() => error); })
      ).subscribe(() => {
        this.populateGroupList();
        this.selectedToMerge = [];
        this.isGroupItemSelected = false;
        this.nav.toggleLoading(false);
      });
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  searchGroups(searchValue:string){
    this.searchValue = searchValue.trim().toLocaleLowerCase();
    setTimeout(()=>{
      this.clearSelectedGroups();
      this.populateGroupList();
    },1400)
  }
  
  filterDateRange() {
    if(this.filterStartDate && this.filterEndDate) {
      this.clearSelectedGroups();
      this.startDate = this.filterStartDate ? dayjs(this.filterStartDate).format('YYYY-MM-DD') : '';
      this.endDate = this.filterEndDate ? dayjs(this.filterEndDate).format('YYYY-MM-DD') : '';
      this.populateGroupList();
    }
  }
  

    resetFilter(){
      this.refreshBrowser();
    }
    
    refreshBrowser() {
      // FORCE REFRESH BROWSER
      this.router.navigateByUrl("/pin-manager/all-pins", { skipLocationChange: true }).then(() => {
          this.router.navigate(["/pin-manager/sample-groups"]);
      });
    }

    protected readonly pinIcons = PIN_ICONS;
}
